import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(40),
            alignSelf: 'stretch',
            paddingY: [remCalc(40), remCalc(40), remCalc(40), remCalc(80)],
        },
        breadcrumb: {
            padding: remCalc(0),
            minHeight: 'unset',
        },
        titleContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(4),
            width: '100%',
        },
        titleSection: {
            display: 'flex',
            padding: `${remCalc(24)} 0`,
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            alignSelf: 'stretch',
            borderBottom: 'small',
            borderColor: 'border.light',
            width: '100%',
        },
        title: {
            textStyle: 'head-large',
            fontWeight: 'medium',
            color: 'text.default',
        },
        subtitle: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'text.default',
        },
        cardsContainerDesktop: {
            display: ['none', 'none', 'none', 'flex'],
            alignItems: 'stretch',
            gap: [
                `${remCalc(8)} ${remCalc(24)}`,
                `${remCalc(8)} ${remCalc(24)}`,
                `${remCalc(8)} ${remCalc(24)}`,
                remCalc(24),
            ],
            alignSelf: 'stretch',
            alignContent: ['flex-start', 'flex-start', 'flex-start', 'unset'],
            flexWrap: ['wrap', 'wrap', 'wrap', 'unset'],
        },
        cardsContainerMobile: {
            display: ['flex', 'flex', 'flex', 'none'],
            alignItems: 'flex-start',
            gap: [
                `${remCalc(8)} ${remCalc(24)}`,
                `${remCalc(8)} ${remCalc(24)}`,
                `${remCalc(8)} ${remCalc(24)}`,
                remCalc(24),
            ],
            alignSelf: 'stretch',
            alignContent: ['flex-start', 'flex-start', 'flex-start', 'unset'],
            flexWrap: ['wrap', 'wrap', 'wrap', 'unset'],
        },
        singleCardContainer: {
            display: 'flex',
            width: ['100%', '100%', '100%', remCalc(332)],
            height: ['unset', 'unset', 'unset', 'auto'],
            alignSelf: 'stretch',
            padding: remCalc(24),
            alignItems: 'center',
            gap: remCalc(19),
            borderRadius: 'medium',
            bg: 'background.neutral.hover',
        },
        cardInnerContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(16),
            alignSelf: 'stretch',
            minHeight: remCalc(66),
            height: '100%',
        },
        cardIcon: {
            width: remCalc(40),
            height: remCalc(40),
        },
        cardDescriptionContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: '1 0 0',
            alignSelf: 'stretch',
        },
        cardDescription: {
            textStyle: 'body-large',
            fontWeight: 'normal',
            color: 'text.default',
        },
        labelAndButtonContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
        buttonLabel: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'text.default',
            alignSelf: 'stretch',
        },
        button: {
            display: 'flex',
            width: remCalc(332),
            height: remCalc(40),
            minWidth: remCalc(140),
            maxHeight: remCalc(40),
            padding: `${remCalc(18)} ${remCalc(24)}`,
            justifyContent: 'center',
            alignItems: 'center',
            border: null,
            borderColor: 'dark',
            borderStyle: 'solid',
            background: 'button.background.primary-default',
        },
        buttonText: {
            textStyle: 'body-medium',
            fontWeight: 'bold',
            color: 'button.text.primary-default',
        },
        infoBannerContainer: {
            display: 'flex',
            padding: [
                `${remCalc(22)} ${remCalc(24)}`,
                `${remCalc(22)} ${remCalc(24)}`,
                `${remCalc(22)} ${remCalc(24)}`,
                `${remCalc(22)} ${remCalc(160)} ${remCalc(22)} ${remCalc(24)}`,
            ],
            flexDirection: ['column', 'column', 'column', 'unset'],
            alignItems: 'flex-start',
            gap: remCalc(60),
            alignSelf: 'stretch',
            borderRadius: remCalc(8),
            border: 'small',
            borderColor: 'border.light',
            borderStyle: 'solid',
        },
        infoBannerInnerContainer: {
            display: 'flex',
            alignItems: ['flex-start', 'flex-start', 'flex-start', 'center'],
            gap: [remCalc(24), remCalc(24), remCalc(24), remCalc(40)],
            flex: '1 0 0',
            flexDirection: ['column', 'column', 'column', 'unset'],
            justifyContent: ['center', 'center', 'center', 'unset'],
            alignSelf: ['stretch', 'stretch', 'stretch', 'unset'],
        },
        infoImage: {
            width: remCalc(172),
            height: remCalc(96),
        },
        infoLabelContainer: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: ['stretch', 'stretch', 'stretch', 'unset'],
        },
        infoTitle: {
            textStyle: 'body-xlarge',
            fontWeight: 'normal',
            color: 'text.default',
            alignSelf: 'stretch',
        },
        infoDescription: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'text.default',
            alignSelf: 'stretch',
        },
        link: {
            overflow: 'hidden',
            color: 'button.text.text-default',
            textOverflow: 'ellipsis',
            textStyle: 'body-small',
            fontWeight: 'normal',
            textDecoration: 'underline',
        },
        headerStepperContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: remCalc(80),
            width: '100%',
        },
        bottomContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(40),
            alignSelf: 'stretch',
        },
        labelSearchOuterContainer: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: remCalc(60),
            alignSelf: 'stretch',
        },
        labelSearchInnerContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: '1 0 0',
        },
        labelSearchTitle: {
            textStyle: 'head-medium',
            fontWeight: 'medium',
            color: 'text.default',
            alignSelf: 'stretch',
        },
        labelSearchDescription: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'text.default',
            alignSelf: 'stretch',
        },
        searchBarOuterContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        searchBarContainer: {
            display: 'flex',
            minWidth: remCalc(140),
            padding: `${remCalc(8)} ${remCalc(0)}`,
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        exampleLabel: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.default',
            alignSelf: 'stretch',
        },
        infoBannerBox: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
    },
    variants: {
        productSearch: {
            container: {
                gap: [remCalc(40), remCalc(40), remCalc(40), remCalc(80)],
            },
            productNotFoundInnerContainer: {
                w: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: remCalc(16),
                alignSelf: '1 0 0',
            },
            headerStepperContainer: {
                gap: [remCalc(40), remCalc(40), remCalc(40), remCalc(80)],
            },
            infoBannerContainer: {
                alignItems: 'center',
                gap: remCalc(24),
            },
            infoImage: {
                width: remCalc(120),
                height: remCalc(110),
            },
            infoTitle: {
                textStyle: 'body-large',
            },
            infoDescription: {
                textStyle: 'body-small',
            },
            infoLabelContainer: {
                gap: [remCalc(16), remCalc(16), remCalc(16), remCalc(8)],
            },
            infoBannerInnerContainer: {
                gap: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
            },
            infoBannerBox: {
                flexDirection: ['column', 'column', 'column', 'unset'],
                gap: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
            },
            tryAgainButton: {
                w: '100%',
                maxW: {base: 'unset', md: remCalc(332)},
                mt: remCalc(8),
            },
        },
        'account-product-registration': {
            singleCardContainer: {
                width: '100%',
            },
            cardInnerContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(16),
                alignSelf: 'stretch',
                minHeight: remCalc(44),
            },
        },
        editRegisteredProductForm: {
            container: {
                paddingY: 0,
            },
            headerStepperContainer: {
                gap: remCalc(24),
                paddingBottom: remCalc(24),
                alignItems: 'flex-start',
                borderBottom: 'small',
                borderSyle: 'solid',
                borderColor: 'border.light',
            },
            headerBackButton: {
                textSyle: 'body-small',
                fontWeight: 'normal',
            },
            headerTitle: {
                textStyle: 'head-xlarge',
                fontWeight: 'medium',
            },
        },
    },
}
